import * as React from 'react';
import PopupButtons from './PopupButtons';
import Pricing from '../../../../../models/data/Pricing';
import Spread from '../../../../../models/data/Spread';
import YieldEditor from './pricing/YieldEditor';
import SpreadEditor from './pricing/SpreadEditor';
import BasisSwitch from './guidance/BasisSwitch';
const PricingPopup = ({ data, hasOverride, save }) => {
    const [basis, setBasis] = React.useState(() => data?.basis() ?? 'spread');
    const [pricing, setPricing] = React.useState(() => {
        const initialPricing = data?.override?.pricing ?? data?.data?.pricing;
        if (initialPricing !== undefined) {
            return initialPricing;
        }
        const initialBasis = data?.basis();
        const initialBenchmark = data?.benchmark();
        if ((initialBasis === undefined || initialBasis === 'spread') && initialBenchmark !== undefined) {
            const spread = new Spread({ benchmark: initialBenchmark });
            return new Pricing({ spread });
        }
        return new Pricing();
    });
    const onChangeSpread = React.useCallback((event) => {
        const newPricing = new Pricing({ spread: event.target.value });
        setPricing(newPricing);
    }, []);
    const onChangeYield = React.useCallback((event) => {
        const newPricing = new Pricing({ yield: event.target.value });
        setPricing(newPricing);
    }, []);
    const content = React.useMemo(() => {
        switch (basis) {
            case 'spread':
                return React.createElement(SpreadEditor, { value: pricing.spread, onChange: onChangeSpread });
            case 'yield':
                return React.createElement(YieldEditor, { value: pricing.yield, onChange: onChangeYield });
        }
        ;
    }, [basis, onChangeSpread, onChangeYield, pricing.spread, pricing.yield]);
    return (React.createElement(React.Fragment, null,
        React.createElement(BasisSwitch, { basis: basis, setBasis: setBasis }),
        content,
        React.createElement("div", { style: { display: 'flex', justifyContent: 'right', marginTop: '0.5rem' } },
            React.createElement(PopupButtons, { isDisabled: false, hasOverride: hasOverride, save: save, value: pricing }))));
};
export default PricingPopup;
